import {
  AvailableVariantList as LoaderAvailableVariantList,
  LoaderProps,
} from './Loader.types';

import Loader from './Loader';

export { Loader, LoaderAvailableVariantList, LoaderProps };
